import { render } from "./CraScheduleList.vue?vue&type=template&id=4b2874b2"
import script from "./CraScheduleList.js?vue&type=script&lang=js"
export * from "./CraScheduleList.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__